<template>
    <ul class="comparison-additional">
        <li class="mpg-combined" v-if="!fuelTypeElectric(derivative.fuelTypeDescription)">
            <span class="key">
                MPG
            </span>
            <span class="value">
                {{quote.derivedMPG}}
            </span>
        </li>

        <li class="electric-range-combined" v-if="fuelTypeElectricOrPluginHybrid(derivative.fuelTypeDescription)">
            <span class="key">
                {{derivative.primaryTechnicalItems['electricRange(Combined)'].technicalItemCaption }}
            </span>
            <span class="value">
                {{derivative.primaryTechnicalItems['electricRange(Combined)'].technicalItemValue }}
            </span>
        </li>
        <li class="electric-range-combined" v-if="fuelTypeElectricOrPluginHybrid(derivative.fuelTypeDescription)">
            <span class="key">
                {{derivative.primaryTechnicalItems['enginePowerKW'].technicalItemCaption }}
            </span>
            <span class="value">
                {{derivative.primaryTechnicalItems['enginePowerKW'].technicalItemValue }}
            </span>
        </li>
        <li class="p11d-value">
            <span class="key">P11d Value</span>
            <span class="value">£{{ p11dValue }}</span>
        </li>
        <li class="c02-combined">
            <span class="key">
                {{derivative.primaryTechnicalItems['cO2(Combined)'].technicalItemCaption }}
            </span>
            <span class="value">{{derivative.primaryTechnicalItems['cO2(Combined)'].technicalItemValue }}
            </span>
        </li>
        <li class="engine-size" v-if="!fuelTypeElectricOrPluginHybrid(derivative.fuelTypeDescription)">
            <span class="key">
                {{derivative.primaryTechnicalItems['engineSize'].technicalItemCaption }}
            </span>
            <span class="value">
                {{derivative.primaryTechnicalItems['engineSize'].technicalItemValue }}
            </span>
        </li>
        <li class="transmission">
            <span class="key">
                {{derivative.primaryTechnicalItems['transmission'].technicalItemCaption }}
            </span>
            <span class="value">
                {{derivative.primaryTechnicalItems['transmission'].technicalItemValue }}
            </span>
        </li>
        <li class="fuel-type">
            <span class="key">Fuel Type</span>
            <span class="value">{{ derivative.fuelTypeDescription }}</span>
        </li>
    </ul>
</template>

<script>
import {fuelTypeElectric, fuelTypeElectricOrPluginHybrid} from "@/helpers/fuel-type";

export default {
    name: 'comparison-additional',
    methods: {fuelTypeElectric, fuelTypeElectricOrPluginHybrid},
    props: [
        'quote',
        'derivative',
        'p11dValue',
    ]
};
</script>

<style scoped>

</style>
